export default __webpack_public_path__ + "static/media/ShrinkingMap.aa69fee3.jpg";